<template>
  <section class="section section-shaped section-lg my-0">
    <div class="shape shape-style-1 bg-gradient-default">
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
    </div>
    <div class="container pt-lg-md">
      <div class="row justify-content-center">
        <div class="col-lg-5">
          <card type="secondary" shadow
                header-classes="bg-white pb-5"
                body-classes="px-lg-5 py-lg-5"
                class="border-0">
            <template>
              <div v-if="login_errado" class="alert alert-danger" role="alert">
                Número de inscrição ou CPF inválido.
              </div>
              <div class="text-muted text-center mb-3">
                <small>Entre com:</small>
              </div>
              <div class="btn-wrapper text-center">
              </div>
            </template>
            <template>
              <form @submit.prevent="envia_login" role="form">
                <base-input v-model="username" alternative
                            class="mb-3"
                            v-mask="'#######-#'"
                            placeholder="Número de inscrição"
                            addon-left-icon="ni ni-single-02">
                </base-input>
                <base-input v-mask="'###.###.###-##'" v-model="password" alternative

                            placeholder="CPF"
                            addon-left-icon="ni ni-badge">
                </base-input>

                <div class="text-center">
                  <base-button native-type="submit" type="primary" class="my-4">Entrar</base-button>
                </div>
              </form>
            </template>
          </card>
          <div class="row mt-3">
            <div class="col-6">
              <a href="#" class="text-light">
                <!--                <small>Esqueci minha senha</small>-->
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import axios from 'axios';
import {useRouter} from 'vue-router';
import Vue from 'vue'
import vueCrypt from 'vue-crypt'
import {cpf} from "cpf-cnpj-validator";

export default {
  name: 'Login',
  data() {
    return {
      username: '',
      password: '',
      login_errado: false,
      logins: [{cpf: 321., num_cand: 123}]
    }
  },
  methods: {
    envia_login: async function () {

      const encryptedText = this.CryptoJS.AES.encrypt("Hi There!", 'secret key 123').toString()
      const decryptedText = this.CryptoJS.AES.decrypt('U2FsdGVkX1+rGzJrqd1xvB4s0Sxxmcl9dbo4sUwcMsE=', 'secret key 123').toString(this.CryptoJS.enc.Utf8)

      const encrypt = (texto) => {
        return this.CryptoJS.AES.encrypt(texto, 'yqKdRqWEAywufSJCZpvPUF5e929UKqMh5eh7AMP5Xpv2FrmdpFeSsnVkyTGvrhPRUG48tZtn32sEGz2R8tDrGcR6wTyYwhdCEvZxbdW42SYpKF7HvrW2XK6zjuWX9946tTx5RhycNDEW8uS475mRVNASZ4CW4v4RhBS5SYHCNHc6DjpwpzWcwuMvTQzCBzMtGbXF8ud4qXhcXnwAQ3xef2tQz3ZeBjvhu32zNGY5PXem92HX3MLRhuw78TqUVsUT').toString()
      }
      const decrypt = (texto) => {
        return this.CryptoJS.AES.decrypt(texto, 'yqKdRqWEAywufSJCZpvPUF5e929UKqMh5eh7AMP5Xpv2FrmdpFeSsnVkyTGvrhPRUG48tZtn32sEGz2R8tDrGcR6wTyYwhdCEvZxbdW42SYpKF7HvrW2XK6zjuWX9946tTx5RhycNDEW8uS475mRVNASZ4CW4v4RhBS5SYHCNHc6DjpwpzWcwuMvTQzCBzMtGbXF8ud4qXhcXnwAQ3xef2tQz3ZeBjvhu32zNGY5PXem92HX3MLRhuw78TqUVsUT').toString(this.CryptoJS.enc.Utf8);
      }

      const gera_file_name = (cpf, num_cand) => {

        let candidato = {CPF: cpf, NUMEROINSC: num_cand}
        let cod_projeto = '2106_pt'
        let codigo_meio = candidato.CPF.replace(/\./g, '').replace('-', '') * 7919;
        codigo_meio = codigo_meio.toString()

        let codigo_arquivo = parseInt(codigo_meio.substring(0, 5)) * parseInt(candidato.NUMEROINSC.replace('-', '')) * 13 + '_'
            + String.fromCharCode(65 + parseInt(codigo_meio[3]))
            + String.fromCharCode(parseInt(codigo_meio[1] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[1]))
            + String.fromCharCode(parseInt(codigo_meio[4] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[5]))
            + String.fromCharCode(parseInt(codigo_meio[3] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[2]))
            + String.fromCharCode(parseInt(codigo_meio[7] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[7]))
            + '-'
            + String.fromCharCode(parseInt(codigo_meio[0] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[11]))
            + String.fromCharCode(parseInt(codigo_meio[1] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[9]))
            + String.fromCharCode(parseInt(codigo_meio[5] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[4]))
            + String.fromCharCode(parseInt(codigo_meio[8] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[5]))
            + String.fromCharCode(parseInt(codigo_meio[3] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[8]))
            + '_'
            + String.fromCharCode(parseInt(codigo_meio[2] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[3]))
            + String.fromCharCode(parseInt(codigo_meio[8] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[4]))
            + String.fromCharCode(parseInt(codigo_meio[3] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[6]))
            + String.fromCharCode(parseInt(codigo_meio[6] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[2]))
            + String.fromCharCode(parseInt(codigo_meio[3] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[11]))
            + String.fromCharCode(parseInt(codigo_meio[8] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[9]))

        return codigo_arquivo + '.pdf';
      }


      let cands = [
        {
          "num_cand": "U2FsdGVkX1/P376h/YVJFaiXK+2gZuazpyhPtZipr6Q=",
          "cpf": "U2FsdGVkX19ZJbROjbaXJAbMd7xa2zn/dLV9yRc8OjM="
        }, {
          "num_cand": "U2FsdGVkX1/TT2BCQ6Vq2pR1DBJOhYBsjKSyUko8Jz8=",
          "cpf": "U2FsdGVkX18S3oVhs36dzWOGlBunRDTenhs+f+mbY6M="
        }, {
          "num_cand": "U2FsdGVkX1+NtsPd6atOdzJ3B2COYTYPPPTJWn+7864=",
          "cpf": "U2FsdGVkX1+020lz3NgHuhg8Z1DEej9zBxn2zLMGakw="
        }, {
          "num_cand": "U2FsdGVkX1/S/zwEB9vpz24cuby8BfJ/sRs61W/vS+A=",
          "cpf": "U2FsdGVkX18N2+P6iOaN6rcPbWjM8Y6TaKBaiVJBQjs="
        }, {
          "num_cand": "U2FsdGVkX19Yui+YJhKm0IsGEalgTI+ELLqd/bCLI84=",
          "cpf": "U2FsdGVkX191RhfBnb/K+MaAsOhx5EafRWt5htFeddQ="
        }, {
          "num_cand": "U2FsdGVkX1/Pe/H8kjhrSgU1/qfb92bUKQRu6neOdoE=",
          "cpf": "U2FsdGVkX1/yG6LzL5Ut943S7VgD7kZis1yEF78jWNY="
        }, {
          "num_cand": "U2FsdGVkX18V6fgsLXuIO1EbJ9okgPOr1aVjpN/rzx0=",
          "cpf": "U2FsdGVkX19WmTsglzcHqCM/HAhCdndYgCAfRpQ1AtI="
        }, {
          "num_cand": "U2FsdGVkX1+HOQnirNQ1quNuCBTQkxh0pFK5T7qqU94=",
          "cpf": "U2FsdGVkX1/n3fFo93gXHa/bCSr9FAtT/U1V67+5rEY="
        }, {
          "num_cand": "U2FsdGVkX18nwH3xvitmnBzoH3T/hFn47FnSqmE30zo=",
          "cpf": "U2FsdGVkX1/0DbT7aLkIdHv6o18eUQtmFn3lvLCDEfc="
        }, {
          "num_cand": "U2FsdGVkX1/zSzYNkgByjI9ZAl7MWkoYHUNg6VPoi/8=",
          "cpf": "U2FsdGVkX18wd5LZiA15LU0zhCRAEuirRC2o0XEZmDk="
        }, {
          "num_cand": "U2FsdGVkX19+Dr66PYrASC46kTCy9JQ+08H2kz7w7dw=",
          "cpf": "U2FsdGVkX1/i2x63UvZpe4nUL59x4HxW7YQAjcJmlco="
        }, {
          "num_cand": "U2FsdGVkX1/kLXiYur5p5wPS7p+DCImIX/s/zmT7wMk=",
          "cpf": "U2FsdGVkX1/pRRML5srEBKDhMvpIzm/y7MNfC/pGDa0="
        }, {
          "num_cand": "U2FsdGVkX19jIgpq0kXB6bPMmhI9NOXPcYXoLIMwkhY=",
          "cpf": "U2FsdGVkX1+8tWFJ7pjxqzR6bsPHQIEzO7eCeeggLsI="
        }, {
          "num_cand": "U2FsdGVkX1/Z5EaLXKc4mJUy+tNQ3c11WIkQ69DzS0k=",
          "cpf": "U2FsdGVkX1/7Tbct1EwOYQT1bdb0qpVtZZFZMQzRrfs="
        }, {
          "num_cand": "U2FsdGVkX19ijCOrHT+L+EwnKKdsi9jOkbXW9OvLzE0=",
          "cpf": "U2FsdGVkX18+YvnltaX4E4hkUKY18GofM2yiJFyM9gU="
        }, {
          "num_cand": "U2FsdGVkX1/RoqgbdkDTSJEdHtwOhJ2srPrP/Xh21dQ=",
          "cpf": "U2FsdGVkX18bdwSODqXkiIx9TyNAG7HeOisLxof2Cy0="
        }, {
          "num_cand": "U2FsdGVkX1+1JO3YrSPeHu+htZ37XTDh44DU4u/WocQ=",
          "cpf": "U2FsdGVkX196ewZQozS/XTFv4UN38rjvLvtmWKioGbQ="
        }, {
          "num_cand": "U2FsdGVkX18SBFvI4Dr/KOQHLBsXam6Mw3OoeX2Aqtk=",
          "cpf": "U2FsdGVkX19czDxjfvtL28Z51jH7KBApJJy+tsDmEp8="
        }, {
          "num_cand": "U2FsdGVkX19zUVNOPb+vV2ib+eozuWTllAHjEiGRM8Y=",
          "cpf": "U2FsdGVkX1//ZsqQ1XxOOmy35yqN3dPUPWz0afLeA9o="
        }, {
          "num_cand": "U2FsdGVkX180uOcM7iuRL6ALV2R6KARvQh/K5gi+65g=",
          "cpf": "U2FsdGVkX1/k4hp5Jfkm8a5/aczDZp/XiNBkYJyVJz4="
        }, {
          "num_cand": "U2FsdGVkX18rvJhLG15H/sqMsIU3Gb7a1l4jyYF6WaA=",
          "cpf": "U2FsdGVkX18Sr50ei7Mc5sI8Abt7nlJmZIF4gRwP0Ng="
        }, {
          "num_cand": "U2FsdGVkX1/jLUyucggLlnyhDwa+j7678nW4o4kxypg=",
          "cpf": "U2FsdGVkX1+L3lkVOwxl+6U0/brtidmf/VZN9uhIEKU="
        }, {
          "num_cand": "U2FsdGVkX197ihENY8hm4iqG1zoWUMDn/ZLjgY5A+1c=",
          "cpf": "U2FsdGVkX1+aY9foWeUxdZFo2qzOITdtys07+WX8F2I="
        }, {
          "num_cand": "U2FsdGVkX1+icDIjVZBaIGGE+/yJ5IGr+nXh05cUd08=",
          "cpf": "U2FsdGVkX1+CFjEYS9GF6Kl4cFk1aL5goLXnkJUNgH8="
        }, {
          "num_cand": "U2FsdGVkX1+quJbX9WuaIyA10aviCOHdEjHeXOYXhfo=",
          "cpf": "U2FsdGVkX1+9f0X0MEPjGhkvPJWWjv13otk52KtkhhI="
        }, {
          "num_cand": "U2FsdGVkX19D6DfIeLrDpBqNE5HmRL4b/NUleiTL6g0=",
          "cpf": "U2FsdGVkX1+sDjhOaXrdlI9G3iHtcpCh66ZCJ8ekeyo="
        }, {
          "num_cand": "U2FsdGVkX188Vg3g6J333g7VHJgsB0EvrhWZ/jKX9EY=",
          "cpf": "U2FsdGVkX195NOFMCEbbQy5hmXyNhGgRJD2oRfbVvcI="
        }, {
          "num_cand": "U2FsdGVkX1+y7fg9xqiq3ZwR5VnouFGhP2Ew0Yfr1pw=",
          "cpf": "U2FsdGVkX1+XODbSCw74W+y9Aog1c2t+C3OX1PiCXAc="
        }, {
          "num_cand": "U2FsdGVkX1/0hXw+lZjv5RHzt1Fc6LcQ48iJqMKRx5A=",
          "cpf": "U2FsdGVkX1+F+pngGsScQ4MGWPyB40Og6LReFqbFvEM="
        }, {
          "num_cand": "U2FsdGVkX1+AKJ5P8egeFPL2H5JLFYZEOEVNUgUu10w=",
          "cpf": "U2FsdGVkX199PLAemjt0PrrcXPh0tokoP09L2Nyqy0I="
        }, {
          "num_cand": "U2FsdGVkX19BUagiMZkAcPUnYQ43sTx1g33VBGzTcGk=",
          "cpf": "U2FsdGVkX1+eh6mOTFBVzvWEuJ9frV6YpoXBoexdd4s="
        }, {
          "num_cand": "U2FsdGVkX1+Aqu1qp/ccNhUnQjjbAVWuTtclN2aeUVo=",
          "cpf": "U2FsdGVkX18YuyjRQSR8kDeSCijpSfjuoBYTxHhZ9qQ="
        }, {
          "num_cand": "U2FsdGVkX1+TD5eEqYjGutg2ty4ojIIkYdPSKlRTExM=",
          "cpf": "U2FsdGVkX183jQ8O9dixEXwe6RoIBjfEqtjs7js+3vk="
        }, {
          "num_cand": "U2FsdGVkX18cXkK7y48+KU1eWEXGReuHvs16+wkx2ho=",
          "cpf": "U2FsdGVkX18ZbbmTQmwN+ihmAhTNnR+sYtvBcPyRqlg="
        }, {
          "num_cand": "U2FsdGVkX187DSgPuaSwOUxB4aivQ20lxyKVrgAwzUg=",
          "cpf": "U2FsdGVkX1+u0n0dN0cWuA0QffqaUY9537Ag7sQFuU8="
        }, {
          "num_cand": "U2FsdGVkX1+lVIdN8/qKGx3n3GvaDOdUeJSz1oF1SNM=",
          "cpf": "U2FsdGVkX19pcLrN6TPJc8MNlIXG/4nP2hHNXr9RM/Y="
        }, {
          "num_cand": "U2FsdGVkX1/Gw1d0Gj2WnjUPfm1LytbzQLgdsqpZO4E=",
          "cpf": "U2FsdGVkX1+BDHYKksdV3wgTzzp5WHwZt5gIotPBnhU="
        }, {
          "num_cand": "U2FsdGVkX1/A8q2uldjLwNGme+LhgQoy45UqJFrvHds=",
          "cpf": "U2FsdGVkX19nez7lgTkJ3uFCo6FvhIjwtZpZbGABJbY="
        }, {
          "num_cand": "U2FsdGVkX19B2vjtygqjsPDTXV3h/wvrIiTx1qhZRKI=",
          "cpf": "U2FsdGVkX18wq1qmxh2BddJxbX1POMO98X1fqcLumd4="
        }, {
          "num_cand": "U2FsdGVkX18A9/pyGQXc/ZJy+nLRV3KtCKqNUMYqR7Y=",
          "cpf": "U2FsdGVkX1+v7+58oOfkz1YEZ86W+8vnsHpmGRs6nCg="
        }, {
          "num_cand": "U2FsdGVkX19dxWTZ3ASnc0fUidko0EsQVt6CYKD2nMM=",
          "cpf": "U2FsdGVkX1/JXn4ALKFAyZ0iXrd4rpS1l3peLBUMxSE="
        }, {
          "num_cand": "U2FsdGVkX1/GiZE7x1KSEhHXM4Sl3Q3a+UFTo6oFEfU=",
          "cpf": "U2FsdGVkX1+3e4LdfWl4Gv32QmV1W7qLIThEwhae7Jw="
        }, {
          "num_cand": "U2FsdGVkX19qKS48SHQXtXPFgFRTmdFXDTlaXRUlgE8=",
          "cpf": "U2FsdGVkX18M5UdVDxEmrzrXpHT6bX+WVo7k7lKs6F8="
        }, {
          "num_cand": "U2FsdGVkX1+pjJ6ZnGQEobGCkqxlfZpUIRoahnB1ZnA=",
          "cpf": "U2FsdGVkX1/AWy1ZXC+lTgJZVFMsFNDhI5nF9TBL89E="
        }, {
          "num_cand": "U2FsdGVkX18QRB2jf0vfCLnlw6gszimfRfAOR1iYIuQ=",
          "cpf": "U2FsdGVkX18DwXf7ZK4aIpvZOuVwIN12uM3CIABQRa4="
        }, {
          "num_cand": "U2FsdGVkX19nkdHAuDsuLXZX7gx//rlri9kJ6OhRPsg=",
          "cpf": "U2FsdGVkX1/kbLFlNa5C0E/be8kOs1AaWfCAZMZu/H0="
        }, {
          "num_cand": "U2FsdGVkX18E1dSYEMaKkYub/zDXxWAiL2LrLo4f84Y=",
          "cpf": "U2FsdGVkX18tsSf3Pr78AQHSUls6Yb4BduNib0DPzdY="
        }, {
          "num_cand": "U2FsdGVkX19kIL9asH3UQE6O9DyF8kbbfX55ABQIWvc=",
          "cpf": "U2FsdGVkX1+ZUM9XfXbZ5EsjBiXxBVdzSqFxeowxl6s="
        }, {
          "num_cand": "U2FsdGVkX1+EIFRgM8DqxVD8dVU79cMpVt+uSApT/Nw=",
          "cpf": "U2FsdGVkX18iqQDdtwSHUpeEMyECjlRgg+cih4cqToA="
        }, {
          "num_cand": "U2FsdGVkX1/NUzYSaazeDHRjCt4wIPBXtRx/C+6JTCM=",
          "cpf": "U2FsdGVkX1+Eeva5QTDlvdiJIZ7yRFA3m1FhcLg0/EE="
        }, {
          "num_cand": "U2FsdGVkX187MJ4V3fKuix7NBqaoZp+ntH1D6sFmRU8=",
          "cpf": "U2FsdGVkX1/vgYXpaPBPSBaScA50/M3T5cXuLNgzNtc="
        }, {
          "num_cand": "U2FsdGVkX18xsWc2Ok85+Z4ZJDdYIYoqmOaQUx155Zo=",
          "cpf": "U2FsdGVkX18zizcTJQbk7Y6Z2KG2DtK7zZEjNNi7S/w="
        }, {
          "num_cand": "U2FsdGVkX199HkdcC+DbS4G4D1wLweBdoFanm5fvJ7o=",
          "cpf": "U2FsdGVkX18U8QXlLn425+uA+XIi0OwraMq0R8HQObA="
        }, {
          "num_cand": "U2FsdGVkX1/joy45+2xsgd8XmNlexjrbOIW5OITvqOs=",
          "cpf": "U2FsdGVkX18ntfzV8UcAp9EpgBjWkSBjqBdXsxjKArU="
        }, {
          "num_cand": "U2FsdGVkX1/x6K0x7GOlEmUOrcmJWxXLWzK0UCqxUsg=",
          "cpf": "U2FsdGVkX18aYNAt5lSkI/NvktXOdi0fMdKEjdBRMS0="
        }, {
          "num_cand": "U2FsdGVkX18upt1yNLuYeTfofCU6kVBValLEB9paCLc=",
          "cpf": "U2FsdGVkX1/xGL1hpA30Mh+2xxfU6YiDedWxiQX/Jfc="
        }, {
          "num_cand": "U2FsdGVkX1+rMBjrtyBefT+DBh5HCvLrouM10F7Dxxc=",
          "cpf": "U2FsdGVkX191B6jQ7sk/tFQHPmbJeiIU8tuMkmOLdRA="
        }, {
          "num_cand": "U2FsdGVkX1/WuXEcQoQgmZ7ax7dd7Kw99xRDurJTmvo=",
          "cpf": "U2FsdGVkX19XpGAZwRV+2+YF6nA/ncowt4nqSBHRCxA="
        }, {
          "num_cand": "U2FsdGVkX19onDXgVN2gCXuLJqonVYFIAvvyzEAeJ1I=",
          "cpf": "U2FsdGVkX1+whkYwe75i416Md9GF6lKVLYqM/5HAfTY="
        }, {
          "num_cand": "U2FsdGVkX1/wGrgv5o/5iOnyqigxUNwsMFEcitZMhB8=",
          "cpf": "U2FsdGVkX1+9lBeblU0ZcDq1j2gjptw6UvXXcN4Z/7c="
        }, {
          "num_cand": "U2FsdGVkX18qYE81cKPPZAiL328qUXeOVz+A+gO1YAg=",
          "cpf": "U2FsdGVkX1/FxtckOSQWCLVlqLBWPMMsk8IGWHiEQtU="
        }, {
          "num_cand": "U2FsdGVkX1+0rW8B8GEpXtxf6HbVlUqc74V3qxhT1KM=",
          "cpf": "U2FsdGVkX1+Lr0Z/7d/Y4M9DTR5NOkjEIg1hkGmqzsY="
        }, {
          "num_cand": "U2FsdGVkX1+dlMbM+6hoH9OYPQGhui/S1Xurq7Bo8Ak=",
          "cpf": "U2FsdGVkX1/66S1a8RMEVb5TsP6kVSXYYeEWz2nuPPw="
        }, {
          "num_cand": "U2FsdGVkX1+xK2bn5xP7s55k5TTDzuaGPekvo06Q7Fw=",
          "cpf": "U2FsdGVkX194lX1rug2OYoe1tTdBvtSsMlyQKILF+3I="
        }, {
          "num_cand": "U2FsdGVkX18w8N/RW7DsmtrTY4LOVn10RdFZk2l5IYk=",
          "cpf": "U2FsdGVkX1+vR4RSytstTvmHksp7PdUoKadmOsCME1Q="
        }, {
          "num_cand": "U2FsdGVkX1+QKPU601EUD1jdn5+NOWi3iIHDLtYfAUI=",
          "cpf": "U2FsdGVkX19Uz4jvaf3fkREdeogIhiBcEsSd4G4VOVk="
        }, {
          "num_cand": "U2FsdGVkX18x8EJ+ZoTNJdOUrFD1Uhb/6mxUnlXvkzU=",
          "cpf": "U2FsdGVkX1/uW7j1ooeio29uOVYxzUyxJJR4qRBo+9Q="
        }, {
          "num_cand": "U2FsdGVkX1/NspcuIb3vBH95C+qkjGxK3AxDz77JYnE=",
          "cpf": "U2FsdGVkX18f3xI6/C1D9DXBLV4XMXrknelcPRrjFKc="
        }, {
          "num_cand": "U2FsdGVkX18TgDKzRqhjn7Xo47qa0fgBVbQPBN2Ut+I=",
          "cpf": "U2FsdGVkX1+NanneJ+KdmCzv5nitBwaf9aKY1iArA/4="
        }, {
          "num_cand": "U2FsdGVkX1/4qWrzUsTRbmf0uENCPjx9IcsJpJwu+aw=",
          "cpf": "U2FsdGVkX19zMSOnP52ABplP4oRfq+liCdka1LBHsA4="
        }, {
          "num_cand": "U2FsdGVkX1+cOTa6ePlBryjBHcfQob5AnwuD/pnvQBw=",
          "cpf": "U2FsdGVkX1/TALw4y3mNLAe45PdRubzQ6gbGbQ/ENfA="
        }, {
          "num_cand": "U2FsdGVkX1/j1z44B7ZjampYwYmIBoJMboeXbSD/UWY=",
          "cpf": "U2FsdGVkX1/4jQ9eCFSOR8Its6VefhH+cL2SEpYpwUg="
        }, {
          "num_cand": "U2FsdGVkX19z9LDrKvY6dIwRbg4MPQveLJC+x4/e+5A=",
          "cpf": "U2FsdGVkX189OTqF/3+6qhAhhVbwxk0A4QXglzIMqy0="
        }, {
          "num_cand": "U2FsdGVkX1951HzrJgJ/qh4yVJIzpwXMtLpIGvdpc3s=",
          "cpf": "U2FsdGVkX19VSIakxDzbl+loShYT3rk8zoPFP3Io5a4="
        }, {
          "num_cand": "U2FsdGVkX1/Lff3OWJxTQVYEPwjb816kPNT6N6U+zKc=",
          "cpf": "U2FsdGVkX1+nQcuKBcKNhmZoCMI03XUL3mzofxOAqYU="
        }, {
          "num_cand": "U2FsdGVkX1+PAWVjCNhM/g0CGzvJ6XZoa51xk7q4xsA=",
          "cpf": "U2FsdGVkX19WQtMBvPii1GGWhIzQlnc8UgbjLpa3fUg="
        }, {
          "num_cand": "U2FsdGVkX180eFMo8V4JWW/W8oIcMAHSO5gj/Wobweg=",
          "cpf": "U2FsdGVkX1/XNVw1xkNf+9KQGJTxiLTHCtBIVetUlCQ="
        }, {
          "num_cand": "U2FsdGVkX1/HOpaIdfVZpcp38UjVabaxadqyyghyOpo=",
          "cpf": "U2FsdGVkX1+abSS+3RNeTOwLAugEqbQOyBJZAKeqaDg="
        }, {
          "num_cand": "U2FsdGVkX19qwuWu48w+LzsJjGSluZsO5fa8xnEQUSc=",
          "cpf": "U2FsdGVkX1/VfdlhjSdPne/DuhDW6z3AR26ulyxOCZ0="
        }, {
          "num_cand": "U2FsdGVkX18T0CT9SHpouLqVJlWp548GZd5AQt3cCMU=",
          "cpf": "U2FsdGVkX1/oLxdZQmL8Vb0r/f2BaKRq5RPH1s1iUBc="
        }, {
          "num_cand": "U2FsdGVkX1+g3c8k+p40urh1F12bqye7AorUkS1Ih70=",
          "cpf": "U2FsdGVkX19Vpx8KCLkzbVY76p3Yxc8+YQxBaZKtxPE="
        }, {
          "num_cand": "U2FsdGVkX19y0qdcwDXPDdvHBt9lONDic9ATVcfq0MQ=",
          "cpf": "U2FsdGVkX19KErokdpACZ590qOud/pLqqsFo7UkIwUs="
        }, {
          "num_cand": "U2FsdGVkX1/D1cKNrhkjvNLO3nmHzyRsCu4fE4XY8jo=",
          "cpf": "U2FsdGVkX1+YWEqpFdUPAa5k1Y7rbHziWz7YVVVs5Bc="
        }, {
          "num_cand": "U2FsdGVkX19GnKLtz05THtaHGujpsJwJ1VIAmq6As+8=",
          "cpf": "U2FsdGVkX186cceLoCbgnNkJouOAZq81h1Qcs4bT5/w="
        }, {
          "num_cand": "U2FsdGVkX1+fESosNiNrR8kAi4828jSKJxa2ntnY2mo=",
          "cpf": "U2FsdGVkX1+GxdmN8gdfGH9yetaKC75IH6wpENQUp2E="
        }, {
          "num_cand": "U2FsdGVkX1+v+/GhBceViIVxEt9XADQ9Li+gCq57lbg=",
          "cpf": "U2FsdGVkX19cQxgSyZ9s6J7+atPVG/UX4Ksp8uEM8+s="
        }, {
          "num_cand": "U2FsdGVkX18wxPpGUQraSAir8BsFMXTDoII7W20Qyvk=",
          "cpf": "U2FsdGVkX19cVHcfi2/fcceNfkM0wH/apYJxnUHlCvQ="
        }]


      try {
        let concurso = this.$route.params.concurso;
        localStorage.setItem('concurso', concurso);

        for (let login of cands) {
          let num_cand_decripted = decrypt(login.num_cand);
          let cpf_decripted = decrypt(login.cpf);

          // console.log(num_cand_decripted,cpf_decripted)
          if (num_cand_decripted == this.username && cpf_decripted == this.password) {
            console.log(`Logged`)
            let nome_arquivo = (gera_file_name(cpf_decripted, num_cand_decripted))
            nome_arquivo = nome_arquivo.replace(/\x00/g, '-');


            // alert(`Logou`);
            let url = (`https://fs.ibfc.org.br/arquivos/2204/2204_rec_pox/${nome_arquivo}`)
            return window.location = url;
          }
        }

        throw new Error(`Login inválido`);


      } catch (error) {
        console.log(error);
        this.login_errado = true;
      }
    }
  }
};
</script>
<style>
</style>
